import { observer } from 'mobx-react-lite'
import AdvisorIntegrationFYIStore, { AdvisorIntegrationFYIStoreProvider, useAdvisorIntegrationFYIStore } from './AdvisorIntegrationFYIStore'
import useStore from 'reusable/mobx-store-utils'
import TextField from '@mui/material/TextField'
import useInitialMount from 'reusable/hooks/useInitialMount'
import AdvisorIntegrationCard from '../AdvisorIntegrationCard'
import FlexAlignRight from 'reusable/mui/utilities/FlexAlignRight'
import HelpOutlineOutlined from '@mui/icons-material/HelpOutlineOutlined'
import Button from '@mui/material/Button'
import { themeConfig }from '@gap/shared/theme'
import SkeletonLoader from 'reusable/mui/skeleton/SkeletonLoader'
import GapDialog from 'reusable/gap-dialog/GapDialog'
import { useOrgGuardStore } from 'features/main/main-router/org-guard/OrgGuardStore'

export default observer(function AdvisorIntegrationFYI() {
   const orgGuardStore = useOrgGuardStore()
   const advisorIntegrationFYIStore = useStore(() => new AdvisorIntegrationFYIStore({ source: 'integrations', orgGuardStore }))

   useInitialMount(() => {
      advisorIntegrationFYIStore.fetch()
   })

   return <AdvisorIntegrationFYIStoreProvider store={advisorIntegrationFYIStore}>

      <AdvisorIntegrationFYIConnectModal />

      <AdvisorIntegrationCard
         title="FYI Docs"
         loading={advisorIntegrationFYIStore.loader.isLoading}
         subTitle="Store client files directly in FYI Docs"
         status={advisorIntegrationFYIStore.status}
         onClick={advisorIntegrationFYIStore.status !== 'connected' ? advisorIntegrationFYIStore.connectDialog.open : advisorIntegrationFYIStore.disconnect}
         icon={<img src="/images/icons/fyi-docs-logo.svg" width="35" />}
      />
   </AdvisorIntegrationFYIStoreProvider>
})

const AdvisorIntegrationFYIConnectModal = observer(function AdvisorIntegrationFYIConnectModal() {
   const advisorIntegrationFYIStore = useAdvisorIntegrationFYIStore()

   return <GapDialog
      size='small'
      title="Connect to FYI Docs"
      subTitle="Store client files directly in FYI Docs"
      modalState={advisorIntegrationFYIStore.connectDialog}
      cancel
      primary={advisorIntegrationFYIStore.primaryGapDialogButton}
   >
      <AdvisorIntegrationFYIConnectModalContent />
   </GapDialog>
})

export const AdvisorIntegrationFYIConnectModalContent = observer(function AdvisorIntegrationFYIConnectModalContent() {
   const advisorIntegrationFYIStore = useAdvisorIntegrationFYIStore()

   return <>
      <FlexAlignRight>
         <Button variant="text" component="a" target="_blank" size="small" rel="noopener noreferrer" startIcon={<HelpOutlineOutlined fontSize='small' sx={{ color: themeConfig.primary['800'] }} />}
            href="https://help.thegaphq.com/portal/en/kb/articles/connecting-to-fyi-docs">
            Where do I find these?
         </Button>
      </FlexAlignRight>

      <SkeletonLoader loading={advisorIntegrationFYIStore.loader.isLoading} title='Connecting'>
         <AccessKeyField />
         <SecretKeyField />
      </SkeletonLoader>
   </>
})

const AccessKeyField = observer(function AccessKeyField() {
   const advisorIntegrationFYIStore = useAdvisorIntegrationFYIStore()

   return advisorIntegrationFYIStore.formHandler.accessId.bindInput(ip =>
      <TextField
         fullWidth
         autoFocus
         label="Access Key ID*"
         sx={{ mt: 2 }}
         {...ip}
      />
   )
})

const SecretKeyField = observer(function SecretKeyField() {
   const advisorIntegrationFYIStore = useAdvisorIntegrationFYIStore()

   return advisorIntegrationFYIStore.formHandler.accessSecret.bindInput(ip =>
      <TextField
         fullWidth
         label="Secret Key ID*"
         sx={{ mt: 2 }}
         {...ip}
      />
   )
})
